import {
  type AppointmentStatus,
  type WidgetSettingsDefinition,
} from "@repo/api";
import { translateAppointmentStatus } from "@repo/ui";

import { COMMON_SETTINGS } from "./commonWidgetSettings";

export const APPOINTMENTS_SETTINGS: WidgetSettingsDefinition[] = [
  { ...COMMON_SETTINGS.COWORKER, additionalControl: { defaultCoworker: true } },
  {
    id: "status",
    title: "label.status",
    type: "selection",
    translator: (key: string) => translateAppointmentStatus(key),
    stringValues: [
      "PUBLISHED",
      "ORDER_RECEIVED",
      "ORDER_RECEIVED_WAITING_FOR_PAYMENT",
      "CANCELLED",
      "CANCELLED_NO_SHOW",
      "STARTED",
      "COMPLETED",
      "PLANNED",
    ] satisfies AppointmentStatus[],
    additionalControl: { selectionMode: "MULTI", showSearch: false },
  },
  {
    id: "appointmentTimeRange",
    title: "label.appointment_time",
    type: "quick_date_selector",
    additionalControl: {
      defaultOptionId: "today",
    },
  },
];
